import React, { ReactNode } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { useSettings } from "app/hooks/useSettings";

interface Props {
    children: ReactNode;
}

const MatxTheme = ({ children }: Props) => {
    const { settings } = useSettings();
    let activeTheme = { ...settings.themes[settings.activeTheme] };

    return (
        <ThemeProvider theme={activeTheme}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
};

export default MatxTheme;
